var bfsModule = require('./bfs.js');
var dfsModule = require('./dfs.js');

exports.bfs = bfsModule.bfs;
exports.bfsFromNode = bfsModule.bfsFromNode;
exports.dfs = dfsModule.dfs;
exports.dfsFromNode = dfsModule.dfsFromNode;
